<template>
  <div>
    <div class="absolute left-[-1px] top-[-24px] z-[999] pr-4">
      <button
        v-tooltip.top="{
          content: $t(addOrPasteTooltip),
          html: true,
        }"
        data-testid="add-structure-top"
        class="grid cursor-pointer items-center rounded-t bg-structure-1 px-0.5 py-0.5 text-white transition duration-300 hover:bg-structure-2"
        @click="addNewOrPaste($event, 'top')"
      >
        <Plus />
      </button>
    </div>
    <div class="absolute bottom-[-24px] left-[-1px] z-[999] pr-4">
      <button
        v-tooltip.top="{
          content: $t(addOrPasteTooltip),
          html: true,
        }"
        data-testid="add-structure-bottom"
        class="grid cursor-pointer items-center rounded-b bg-structure-1 px-0.5 py-0.5 text-white transition duration-300 hover:bg-structure-2"
        @click="addNewOrPaste($event, 'bottom')"
      >
        <Plus />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { Plus } from "@topol/icons";
  import { useDialogsStore } from "@/stores/dialogs";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import getClipboard from "@/utils/getClipboard";
  import { computed } from "vue";

  const props = defineProps<{
    showPaste: boolean;
  }>();

  const dialogsStore = useDialogsStore();
  const mjmlStore = useMjmlStore();

  const isMac = computed(() => {
    return navigator.platform.toUpperCase().indexOf("MAC") >= 0;
  });

  const addOrPasteTooltip = computed(() => {
    if (!props.showPaste) {
      return "editor.add_structure";
    }

    if (isMac.value) {
      return "editor.add_paste_structure_mac";
    }

    return "editor.add_paste_structure";
  });

  function openDialog(direction: "top" | "bottom") {
    dialogsStore.openStructureDialog(direction);
  }

  async function paste(direction: "top" | "bottom") {
    const section = await getClipboard();
    if (Array.isArray(section)) {
      if (section.filter((s) => s.tagName !== "mj-section").length > 0) return;
      for (let i = section.length - 1; i >= 0; i--) {
        const s = section[i];
        mjmlStore.addCopiedSection({ direction: direction, section: s });
      }
      return;
    }
    if (!section || !("tagName" in section) || section.tagName !== "mj-section")
      return;
    setTimeout(() => {
      mjmlStore.addCopiedSection({ direction: direction, section: section });
    }, 20);
  }

  async function addNewOrPaste(event: any, direction: "top" | "bottom") {
    if ((isMac.value && event.metaKey) || (!isMac.value && event.ctrlKey)) {
      if (props.showPaste) {
        await paste(direction);
      }
    } else {
      openDialog(direction);
    }
  }
</script>

<style scoped></style>
